import { Button, chakra, IconButton } from '@chakra-ui/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BELangCurrencySelectProps } from './LangCurrencySelectProps';

export const StyledLangCurrencySelect = styled('div')`
  display: inline-block;
  white-space: nowrap;
`;

const GlobeButton = chakra(IconButton, {
  baseStyle: {
    borderWidth: '1px',
    borderLeftRadius: '24px',
    borderRightRadius: 0,
    borderColor: 'neutral.500',
    width: '84px',
    height: '48px',
    backgroundColor: 'white',
  },
});

export const StyledGlobeButton = styled(GlobeButton)<
  { size: 'md' | 'lg' } & BELangCurrencySelectProps
>`
  width: ${({ size }) => (size === 'md' ? 54 : 84)}px;
  height: ${({ size }) => (size === 'md' ? 40 : 48)}px;
  ${({ currencies, size }) => {
    if (currencies && currencies.length <= 1) {
      return css`
        border-radius: ${size === 'md' ? 20 : 24}px;
      `;
    } else {
      return css`
        border-top-left-radius: ${size === 'md' ? 20 : 24}px;
        border-bottom-left-radius: ${size === 'md' ? 20 : 24}px;
      `;
    }
  }}
  ${({ languages }) =>
    (!languages || languages.length <= 1) &&
    css`
    display: none;
  `}
`;

const LangButton = chakra(Button, {
  baseStyle: {
    borderWidth: '1px',
    borderLeftWidth: 0,
    borderRightRadius: '24px',
    borderLeftRadius: 0,
    borderColor: 'neutral.500',
    width: '84px',
    height: '48px',
    backgroundColor: 'white',
  },
});

export const StyledCurrencyButton = styled(LangButton)<
  {
    size: 'md' | 'lg';
  } & BELangCurrencySelectProps
>`
  width: ${({ size }) => (size === 'md' ? 54 : 84)}px;
  height: ${({ size }) => (size === 'md' ? 40 : 48)}px;
  ${({ languages, size }) => {
    if (languages && languages.length <= 1) {
      return css`
        border-radius: ${size === 'md' ? 20 : 24}px;
      `;
    } else {
      return css`
        border-top-right-radius: ${size === 'md' ? 20 : 24}px;
        border-bottom-right-radius: ${size === 'md' ? 20 : 24}px;
      `;
    }
  }}
  ${({ currencies }) =>
    (!currencies || currencies.length <= 1) &&
    css`
    display: none;
  `}
`;
